module.exports = __webpack_public_path__ + "img/RO recycle.39162d73.jpg";